import { useQuery } from "react-query";

import { Filter, getFilters } from "@/api";
import { useUser } from "@/providers/context";

export const useFilters = () => {
  const { uid } = useUser();

  const query = useQuery<Filter[]>(["filters"], () => getFilters(), {
    enabled: !!uid,
  });

  if (!uid) {
    return { data: [] };
  }

  return query;
};
